import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Equity from "../components/Equity";

const EquityPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Equity Balance' />

        {/* BlankPageLayer */}
        <Equity />
      </MasterLayout>
    </>
  );
};

export default EquityPage;
